import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from 'assets/images/qq.png'
import _imports_1 from 'assets/images/weichat.png'


const _withScopeId = n => (_pushScopeId("data-v-36564472"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-dialog" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "QQ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "WeiChat", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-wendang" }),
  /*#__PURE__*/_createElementVNode("b", null, "项目详细开发过程文档(请点击下方连接)")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://blog.csdn.net/weixin_47529373/article/details/119055893" }, "Vue3+TS管理系统开发流程", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "时间", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  frameborder: "0",
  width: "100%",
  src: "/page/run-time/index.html"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("和我一起来学习前端吧"),
  /*#__PURE__*/_createElementVNode("i", { class: "icon-yiqiguang" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isShow,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isShow) = $event)),
      width: "30%"
    }, {
      default: _withCtx(() => [
        (_ctx.showFlag === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_2,
              _hoisted_3
            ], 64))
          : (_ctx.showFlag === 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_4,
                _hoisted_5
              ], 64))
            : (_ctx.showFlag === 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_6,
                  _hoisted_7
                ], 64))
              : (_ctx.showFlag === 4)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _hoisted_8,
                    _hoisted_9
                  ], 64))
                : _createCommentVNode("", true),
        _hoisted_10
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}